import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
// import { Button, Container, Row, Col } from 'react-bootstrap';
import { activateYairSchedulingAlgorithm } from '../../UserFunctions';
import { Modal, Button} from 'react-bootstrap';

// import { removeSurgery } from '../UserFunctions';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

// **** FOR DEVELOPMENT **** //
// const local_host = 'http://localhost:5000/surgeriessurgical';
const remote_host = 'https://server-soroka-demo.herokuapp.com/surgeries_orthopedic/get_all';


export class CalendarOrthopedic extends Component {

  state = { surgeries: [], full_data_surgeries: [], isLoading: true,modalShow: null, setModalShow: null, info: null };
  colors_arr = ['red','pink','purple','blue','green'];
  getSurgeries = () => {
    fetch(remote_host, {ward_id: '1'})
      .then(data => data.json())
      .then(data => {
        var surgeries_fetched = data.map(surgery => {
          return {
            title: surgery.description, 
            start: surgery.st_time, 
            end: surgery.end_time,
            color: this.colors_arr[surgery.room_number],
            extendedProps:{
              id : surgery.id,
              patient_id: surgery.patient_id,
              request_number: surgery.request_number,
              stagiaire_id: surgery.stagiaire_id,
              senior_id: surgery.senior_id,
              anesthetist_id: surgery.anesthetist_id,
              nurse_id: surgery.nurse_id,
              room_number: surgery.room_number,
              order_in_day: surgery.order_in_day
            }
          }
        })
        this.setState({ surgeries: surgeries_fetched, full_data_surgeries: data, isLoading: false, EventModalShow: false })
        console.log(data);
        
    })
      .catch(e => console.log(e));
  }


  eventClickFunc2 = () => {
    activateYairSchedulingAlgorithm().then((res, err) => {
      if (res) {
        alert('Schedule is ready!')
      } else {
        alert('Something went wrong!')
      }
    })
  }

    eventClickFunc = (info) => {
      

      this.setState({info: info, EventModalShow: true});
      console.log(this.state.info.event);
      info.jsEvent.preventDefault();
    }

    handleDateClick = (start, end, allDay) => { // Need to change Modal to eventClickFunc

      
      }

      componentDidMount() {
        this.getSurgeries();
        
      }

    render() {
      
      function MyVerticallyCenteredModal(props) {
        console.log(props);
        return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
              <h3 style={{ color: 'darkblue', fontWeight: 'bold' }}>Surgery Information</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>{!props.currinfo ? "ERROR" : "Description: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.title}
              <h5>{!props.currinfo ? "ERROR" : "Patient ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.patient_id}
              <h5>{!props.currinfo ? "ERROR" : "Senior Surgeon ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.senior_id}
              <h5>{!props.currinfo ? "ERROR" : "Stagiaire Surgeon ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.stagiaire_id}
              <h5>{!props.currinfo ? "ERRPR" : "Anesthetist ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.anesthetist_id}
              <h5>{!props.currinfo ? "ERRPR" : "Nurse ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.nurse_id}
              <h5>{!props.currinfo ? "ERRPR" : "Room Number: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.room_number}
              <h5>{!props.currinfo ? "ERRPR" : "Order In Day: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.order_in_day}
              <h5>{!props.currinfo ? "ERROR" : "Starting Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.start.toString()}
              <h5>{!props.currinfo ? "ERROR" : "Expected Ending Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.end.toString()}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={props.onHide}>Close</Button>
              {/* {props.currinfo? <Button onClick={props.removefunc()}>remove</Button> : null} */}
            </Modal.Footer>
          </Modal>
        );
      }
      // const [modalShow, setModalShow] = React.useState(false);

      let EventModalClose = () => this.setState({EventModalShow: false, info: null});

   
        return (
          
          <div>
            
            <FullCalendar 
            editable='false'
            selectable='true' 
            dateClick={this.handleDateClick} 
            defaultView="timeGridWeek" 
            plugins={[ dayGridPlugin, bootstrapPlugin, interactionPlugin, listPlugin, timeGridPlugin ]} 
            events={this.state.surgeries}
            nowIndicator='true'
            eventClick={this.eventClickFunc}
            customButtons= {{
              add_event: {
                  text: 'Add Event',
                  click: function() {
                     window.location = '/calendar/addsurgery1';
                  }
              }
            }
            }
            header={{
              left: 'prev,next today, add_event',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            }}
            
            footer={{
                left: 'hi',
                center: 'hello',
                right: 'hei'
            }}

            themeSystem = 'bootstrap'
            />
            <Button variant="danger" onClick={this.eventClickFunc2}>Activate Sheduling Algorithm!</Button>
            <MyVerticallyCenteredModal
              show={this.state.EventModalShow}
                onHide={EventModalClose}
                currinfo ={this.state.info}
            />
            </div>

        )
    }
}

export default CalendarOrthopedic